module.exports = __webpack_public_path__ + "img/me-night-middle-bg_ar.2627a790.png";